// extracted by mini-css-extract-plugin
export var carrierIcon = "_uv-0";
export var carrierLogo = "_uv-1";
export var detailsSection = "_uv-2";